import React, { useEffect, useState } from 'react';

export const EarningsWallet = () => {
  const [balance,  setBalance]  = useState(null);
  const [txns,     setTxns]     = useState([]);
  const [bank,     setBank]     = useState(null);
  const [amount,   setAmount]   = useState('');
  const [loading,  setLoading]  = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error,    setError]    = useState('');
  const [success,  setSuccess]  = useState('');
  const [bankEdit, setBankEdit] = useState(false);
  const [bankForm, setBankForm] = useState({ account_holder: '', account_number: '', ifsc: '', bank_name: '' });
 
  useEffect(() => {
    import('./resellerapi').then(({ walletAPI }) => {
      Promise.all([walletAPI.getBalance(), walletAPI.getTransactions(), walletAPI.getBankDetails()])
        .then(([b, t, bk]) => {
          setBalance(b.data);
          setTxns(t.data || []);
          setBank(bk.data);
          if (bk.data) setBankForm(bk.data);
        })
        .catch(e => setError(e.message))
        .finally(() => setLoading(false));
    });
  }, []);
 
  const handleWithdraw = async () => {
    const amt = parseFloat(amount);
    if (!amt || amt < 100) { setError('Minimum withdrawal is ₹100'); return; }
    if (amt > (balance?.available || 0)) { setError('Insufficient balance'); return; }
    setError(''); setSubmitting(true);
    try {
      const { walletAPI } = await import('./resellerapi');
      await walletAPI.requestPayout(amt);
      setSuccess(`Payout of ₹${amt} requested! Settled within 2 business days.`);
      setAmount('');
      const b = await walletAPI.getBalance();
      setBalance(b.data);
    } catch (e) { setError(e.message); }
    finally { setSubmitting(false); }
  };
 
  const handleSaveBank = async () => {
    setSubmitting(true); setError('');
    try {
      const { walletAPI } = await import('./resellerapi');
      await walletAPI.saveBankDetails(bankForm);
      setBank(bankForm);
      setBankEdit(false);
      setSuccess('Bank details updated!');
    } catch (e) { setError(e.message); }
    finally { setSubmitting(false); }
  };
 
  return (
    <div>
      {error   && <div className="res-error">{error}</div>}
      {success && <div className="res-error" style={{ background: 'rgba(16,185,129,0.1)', borderColor: 'rgba(16,185,129,0.25)', color: 'var(--em-400)' }}>{success}</div>}
 
      {/* Wallet Hero */}
      <div className="wallet-hero">
        <div className="wallet-hero-left">
          <div className="wallet-hero-label">AVAILABLE FOR WITHDRAWAL</div>
          <div className="wallet-hero-amount">
            {loading ? '—' : `₹${Number(balance?.available || 0).toLocaleString('en-IN')}`}
          </div>
          <div className="wallet-hero-pending">
            Pending settlement: <span>₹{Number(balance?.pending || 0).toLocaleString('en-IN')}</span>
          </div>
        </div>
        <div className="wallet-withdraw-form">
          <input
            className="withdraw-input"
            type="number"
            placeholder="Enter amount"
            value={amount}
            min={100}
            max={balance?.available || 0}
            onChange={e => setAmount(e.target.value)}
          />
          <button
            className="withdraw-now-btn"
            disabled={submitting || !amount}
            onClick={handleWithdraw}
          >
            {submitting ? 'Processing…' : 'Request Payout →'}
          </button>
        </div>
      </div>
 
      <div className="wallet-sections-grid">
        {/* Transaction History */}
        <div className="res-card">
          <div className="res-card-title">Payout History</div>
          {loading ? (
            [...Array(4)].map((_, i) => (
              <div key={i} style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
                <div className="skeleton" style={{ width: 36, height: 36, borderRadius: '50%' }} />
                <div style={{ flex: 1 }}>
                  <div className="skeleton" style={{ height: 13, width: '60%', marginBottom: 5 }} />
                  <div className="skeleton" style={{ height: 10, width: '40%' }} />
                </div>
              </div>
            ))
          ) : txns.length === 0 ? (
            <p style={{ color: 'var(--text-3)', fontSize: 13, textAlign: 'center', padding: '1.5rem' }}>
              No transactions yet.
            </p>
          ) : txns.map(t => (
            <div key={t.id} className="txn-item">
              <div className={`txn-icon ${t.type}`}>
                {t.type === 'credit' ? '↙' : '↗'}
              </div>
              <div className="txn-info">
                <div className="txn-desc">{t.description}</div>
                <div className="txn-date">{new Date(t.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</div>
              </div>
              <div className={`txn-amt ${t.type}`}>
                {t.type === 'credit' ? '+' : '−'}₹{Number(t.amount).toLocaleString('en-IN')}
              </div>
            </div>
          ))}
        </div>
 
        {/* Bank Details */}
        <div className="res-card">
          <div className="res-card-title">
            Settlement Bank Account
            <button
              style={{ fontSize: 12, color: 'var(--em-400)', background: 'none', cursor: 'pointer', fontFamily: 'var(--font-body)' }}
              onClick={() => setBankEdit(!bankEdit)}
            >
              {bankEdit ? 'Cancel' : 'Edit'}
            </button>
          </div>
 
          {bankEdit ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              {[
                { key: 'account_holder', label: 'Account Holder Name', type: 'text' },
                { key: 'bank_name',      label: 'Bank Name',           type: 'text' },
                { key: 'account_number', label: 'Account Number',      type: 'text' },
                { key: 'ifsc',           label: 'IFSC Code',           type: 'text' },
              ].map(({ key, label, type }) => (
                <div key={key} className="res-input-group" style={{ marginBottom: 0 }}>
                  <label className="res-input-label">{label}</label>
                  <input
                    className="res-input"
                    type={type}
                    value={bankForm[key] || ''}
                    onChange={e => setBankForm({ ...bankForm, [key]: e.target.value })}
                  />
                </div>
              ))}
              <button className="withdraw-now-btn" style={{ marginTop: 4 }} onClick={handleSaveBank} disabled={submitting}>
                {submitting ? 'Saving…' : 'Save Bank Details'}
              </button>
            </div>
          ) : (
            <>
              {bank ? (
                <>
                  {[
                    { label: 'Account Holder', val: bank.account_holder },
                    { label: 'Bank',           val: bank.bank_name },
                    { label: 'Account No.',    val: `**** **** ${bank.account_number?.slice(-4)}` },
                    { label: 'IFSC',           val: bank.ifsc },
                  ].map(({ label, val }) => (
                    <div key={label} className="bank-row">
                      <span className="bank-row-label">{label}</span>
                      <span className="bank-row-val">{val || '—'}</span>
                    </div>
                  ))}
                  <button className="edit-bank-btn" onClick={() => setBankEdit(true)}>Update Details</button>
                </>
              ) : (
                <div style={{ textAlign: 'center', padding: '1.5rem' }}>
                  <p style={{ color: 'var(--text-3)', fontSize: 13, marginBottom: '1rem' }}>
                    No bank account added yet.
                  </p>
                  <button className="withdraw-now-btn" onClick={() => setBankEdit(true)}>Add Bank Account</button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
 


export default EarningsWallet;